import { render, staticRenderFns } from "./aside-hunt-svg.vue?vue&type=template&id=71c8e170&scoped=true"
import script from "./aside-hunt-svg.vue?vue&type=script&lang=js"
export * from "./aside-hunt-svg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c8e170",
  null
  
)

export default component.exports